import { Text } from '@zillow/constellation';
import React from 'react';
import Notes from './Notes';
import PropTypes from 'prop-types';

import { getPetsSummary } from './Pets.utils';

export default function Pets({ applicants }) {
  const petsSummary = getPetsSummary(applicants);

  return (
    <>
      <Text fontType="bodySmallHeading" as="h3" fontColor="textMedium" id="pets-header">
        Pets
      </Text>
      <Text fontType="body" marginBottom="md">
        {petsSummary}
      </Text>
      <Notes applicants={applicants} />
    </>
  );
}

Pets.propTypes = {
  applicants: PropTypes.arrayOf(
    PropTypes.shape({
      answers: PropTypes.shape({
        firstName: PropTypes.string,
        pets: PropTypes.shape({
          smallDogs: PropTypes.number,
          mediumDogs: PropTypes.number,
          largeDogs: PropTypes.number,
          cats: PropTypes.number,
          other: PropTypes.number,
          description: PropTypes.string,
        }),
      }),
    }),
  ),
};
